import { useNavigate, useParams } from 'react-router-dom'
import { useAllLocalStorage } from '../useStorage/useAllLocalStorage'
import React from 'react'
import { atob, jsonTryParse } from '@ztechapps/common.utils'

export type UseLoginFlowProps = {
  afterLoginPath?: string
  userIdKey?: string
  tokenKey?: string
}
export type UseLoginFlowResult = {
  redirect: (url?: string) => void
  accessToken: string
  userId: string
  authPayload: any
  redirect_url: string
}
export const useLoginFlow = ({
  afterLoginPath = '/account/join',
  userIdKey = 'totalmilk-login-userId',
  tokenKey = 'totalmilk-login-token',
}: UseLoginFlowProps = {}): UseLoginFlowResult => {
  const navigate = useNavigate()
  const localStorage = useAllLocalStorage()

  const { auth = '{}' } = useParams()

  const authAtob = jsonTryParse(atob(auth))

  const accessToken = authAtob?.accessToken
  const userId = authAtob?.userId
  const redirect_url = authAtob?.redirect_url

  const redirect = React.useCallback(
    (navigateTo = afterLoginPath) => {
      try {
        if (!accessToken || !userId) return

        //store this also to the local storage for further request
        localStorage.set(tokenKey, accessToken)
        localStorage.set(userIdKey, userId)

        //we use the native window location here, to properly refresh
        globalThis.window.location.href = navigateTo
      } catch (error) {
        //for somehow there is error, just push ot not-found exception
        //Should navigate to error is really weird
        navigate('/error-in-app')
      }
    },
    [navigate, localStorage, accessToken, userId, tokenKey, userIdKey]
  )

  return { redirect, accessToken, userId, authPayload: authAtob, redirect_url }
}
